/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterTemplateListValueListViewModel } from '../../models/setup-parameter-template-list-value-list-view-model';

export interface GetSetupParameterTemplateListValueById$Params {
  setupParameterTemplateListValueId: number;
}

export function getSetupParameterTemplateListValueById(http: HttpClient, rootUrl: string, params: GetSetupParameterTemplateListValueById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterTemplateListValueListViewModel>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterTemplateListValueById.PATH, 'get');
  if (params) {
    rb.path('setupParameterTemplateListValueId', params.setupParameterTemplateListValueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameterTemplateListValueListViewModel>;
    })
  );
}

getSetupParameterTemplateListValueById.PATH = '/api/v1/SetupParameter/GetSetupParameterTemplateListValueById/{setupParameterTemplateListValueId}';
